import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';

// Components
import RecipeIndex from './Recipe/Index';
import NewRecipe from './Recipe/New';
import EditRecipe from './Recipe/Edit';
import ShowRecipe from './Recipe/Show';
import RecipePicker from './RecipePicker';
import GroceryList from './GroceryList';

export class App extends React.PureComponent {

  render() {
    return (
      <Switch>
        <Route path="/grocery_list" component={GroceryList} />
        <Route path="/recipe_picker" component={RecipePicker} />
        <Route path="/recipes/:id/edit" component={EditRecipe} />
        <Route path="/recipes/new" component={NewRecipe} />
        <Route path="/recipes/:id" component={ShowRecipe} />
        <Route path="/recipes" component={RecipeIndex} />
        <Route exact path="/" component={RecipeIndex} />
      </Switch>
    )
  }
}

